import React from 'react';
import {
  Timeline, Empty, Avatar, Skeleton,
} from 'antd';
import { UserOutlined } from '@ant-design/icons';
import I18n from 'i18n-js';
import { arrayOf, shape, bool } from 'prop-types';
import HistoryItem from './HistoryItem';

const HistoryList = ({ versions = [], loading = false }) => {
  if (loading) return <Skeleton active paragraph={{ rows: 4 }} />;
  if (versions.length === 0) return <Empty description={I18n.t('tickets.history.empty')} />;

  return (
    <Timeline
      className="ticket-history"
      items={versions.map((version) => ({
        dot: (
          <Avatar
            size="small"
            src={version.changedBy?.avatarUrl}
            icon={<UserOutlined />}
          />
        ),
        children: <HistoryItem {...version} />,
      }))}
    />
  );
};

HistoryList.propTypes = {
  versions: arrayOf(shape({})),
  loading: bool,
};

export default HistoryList;
